export const STORE_LOCATOR_MAP_CONFIG = {
	zoom: 3,
	mapTypeControl: false,
	streetViewControl: false,
	scrollwheel: false,
	zoomControl: true,
	fullscreenControl: false,
	gestureHandling: 'cooperative',
};

export const STORE_LOCATOR_DEFAULT_DISTANCE_KM = 40;
export const STORE_LOCATOR_ZOOM_LOCATION = 11;
